import React, { useState, ChangeEvent } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { SxProps } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

interface UploadAvatarProps {
  src: string;
  alt: string;
  onUpload?: (file: File) => void;
  sxBox?: SxProps<Theme>
  sx?: SxProps<Theme>
}

export const AvatarWithUpload: React.FC<UploadAvatarProps> = ({ src, alt, onUpload, sx, sxBox = {} }) => {
  const [hovered, setHovered] = useState(false);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && onUpload) {
      onUpload(file);
    }
  };

  return (
    <Box
      sx={{ position: 'relative', display: 'inline-block', padding: '8px', ...sxBox}}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Avatar src={src} alt={alt}  sx={sx}/>
      {hovered && onUpload && (
        <Tooltip title="Upload">
          <IconButton
            component="label"
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
            }}
          >
            <CloudUploadIcon />
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};